import { render, staticRenderFns } from "./objectionDetail.vue?vue&type=template&id=6312a366&scoped=true&"
import script from "./objectionDetail.vue?vue&type=script&lang=js&"
export * from "./objectionDetail.vue?vue&type=script&lang=js&"
import style0 from "./objectionDetail.vue?vue&type=style&index=0&id=6312a366&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6312a366",
  null
  
)

component.options.__file = "objectionDetail.vue"
export default component.exports